const storageKey = 'audio-guide-keyboard-entry';

export function rememberKeyboardNavigation(event: MouseEvent): void {
  const link = event.target instanceof Element ? event.target.closest<HTMLAnchorElement>('a[href]') : null;
  if (!link || event.defaultPrevented || event.button !== 0 || event.ctrlKey || event.metaKey ||
      event.shiftKey || event.altKey || link.hasAttribute('download') ||
      (link.target && link.target !== '_self') || link.origin !== location.origin) return;

  try {
    sessionStorage.removeItem(storageKey);
    if (event.detail === 0) {
      sessionStorage.setItem(storageKey, JSON.stringify({ url: link.href, createdAt: Date.now() }));
    }
  } catch {
    // Navigation still works when browser storage is unavailable.
  }
}

export function consumeKeyboardNavigation(): boolean {
  try {
    const value = sessionStorage.getItem(storageKey);
    sessionStorage.removeItem(storageKey);
    if (!value) return false;
    const entry = JSON.parse(value);
    const age = Date.now() - entry.createdAt;
    const destination = new URL(entry.url);
    const current = new URL(location.href);
    // The guide router can append #/ when opening its start page.
    destination.hash ||= '/';
    current.hash ||= '/';
    return destination.href === current.href && age >= 0 && age < 30_000;
  } catch {
    return false;
  }
}
